import { render, staticRenderFns } from "./KanbanDialog.vue?vue&type=template&id=14c01826&scoped=true&lang=pug&"
import script from "./KanbanDialog.vue?vue&type=script&lang=ts&"
export * from "./KanbanDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KanbanDialog.vue?vue&type=style&index=0&id=14c01826&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c01826",
  null
  
)

export default component.exports